import { render, staticRenderFns } from "./StandardButtonIcons.vue?vue&type=template&id=14fd7c12&scoped=true"
import script from "./StandardButtonIcons.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardButtonIcons.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fd7c12",
  null
  
)

export default component.exports